'use strict';

var GridFeaturesDirective = function GridFeaturesDirective() {
  return {
    restrict: 'E',
    controller: 'GridFeaturesController',
    transclude: 'true',
    replace: true,
    template: '<div><ng-transclude></ng-transclude></div>'
  };
};
GridFeaturesDirective.$inject = [];
module.exports = GridFeaturesDirective;